import { render, staticRenderFns } from "./Budget.vue?vue&type=template&id=4b851624&scoped=true&"
import script from "./Budget.vue?vue&type=script&lang=js&"
export * from "./Budget.vue?vue&type=script&lang=js&"
import style0 from "./Budget.vue?vue&type=style&index=0&id=4b851624&prod&lang=css&"
import style1 from "./Budget.vue?vue&type=style&index=1&id=4b851624&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b851624",
  null
  
)

export default component.exports